package core.extensions

import common.ECssClasses
import csstype.ClassName

fun ECssClasses.toClassName() = ClassName(this.mClassName)